import { useWindowSize } from "./useWindowSize";
import { isMobile as isMobileBreakpoint } from "@/assets/theme/sizes";

/**
 * Hook for responsive layout detection based on mobile screen width breakpoint.
 *
 * Returns true for mobile layouts (< 768px), excluding tablets and larger screens.
 *
 * For actual device detection (iOS/Android), use `usePlatformDetection` instead.
 * For compact layout detection that includes tablets (< 1024px), use `useIsCompactLayout()`.
 *
 * @returns Boolean - true for mobile layouts (< 768px)
 *
 * @example
 * // Mobile-only detection (< 768px)
 * const isMobile = useIsMobile();
 * if (isMobile) { ... }
 * someFn(isMobile); // works as function argument
 */
export function useIsMobile(): boolean {
  const { width } = useWindowSize();
  return isMobileBreakpoint(width);
}
